import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <header>
      <img src="/crlacayo.svg" alt="" role="presentation" title="crlacayo" id="header-logo" />
    </header>
    <Container className='pt-4'>
      <main>
      <App />
      </main>
      <footer>
        <hr/>
        <img src="/crlacayo.svg" alt="" role="presentation" title="crlacayo" id="footer-logo" />
        &copy; 2026 crlacayo
      </footer>
    </Container>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
